import clsx, { ArgumentArray } from "classnames";
import { extendTailwindMerge } from "tailwind-merge";

import twConfig from "@/../tailwind.config";

const twMerge = extendTailwindMerge((config) => ({
  ...config,
  classGroups: {
    ...config.classGroups,
    "font-size": [
      ...(Array.isArray(config.classGroups["font-size"])
        ? config.classGroups["font-size"]
        : []),
      ...Object.keys(twConfig.theme.fontSize).map((key) => `text-${key}`),
    ],
    "font-weight": [
      ...(Array.isArray(config.classGroups["font-weight"])
        ? config.classGroups["font-weight"]
        : []),
      ...Object.keys(twConfig.theme.fontWeight).map((key) => `font-${key}`),
    ],
  },
}));

export default function cn(...inputs: ArgumentArray) {
  return twMerge(clsx(inputs));
}
